import React, { useContext } from 'react'
import { SummitResponse, defaultState } from '../libs/fetchSummit'
import useSummit from '../libs/useSummit'
import { EnvVariablesContext } from '../contexts/EnvVariablesContext'

export const SummitContext = React.createContext<SummitResponse>(defaultState)

const { Provider } = SummitContext

const SummitProvider = ({ value, children }) => {

  const { hostUrl  } = useContext(EnvVariablesContext)
  const { data } = useSummit(value, hostUrl)

  return <Provider value={data}>{ children }</Provider>

}

export default SummitProvider
